var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVelocityLoopCard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 1.39062L6.80645 6.80998L1 12.6164",
    stroke: "#0550DC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.19531 1L13.0018 6.80645L7.19531 12.6129",
    stroke: "#0550DC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.09766 1L9.90411 6.80645L4.09766 12.6129",
    stroke: "#0550DC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVelocityLoopCard);
export default __webpack_public_path__ + "static/media/VelocityLoopCard.349b746ddf5601ed6ac5a20cc569b8f7.svg";
export { ForwardRef as ReactComponent };